import type { RouteRecordRaw } from 'vue-router';

export const contactUsRoute: RouteRecordRaw = {
  path: `/contact-us`,
  component: () => import('@/modules/contact-us/views/ContactUs.vue'),
  name: 'ContactUs',
  meta: {
    layout: 'main',
  },
};
